import { render, staticRenderFns } from "./stationInfo.vue?vue&type=template&id=180a46a6&scoped=true"
import script from "./stationInfo.vue?vue&type=script&lang=js"
export * from "./stationInfo.vue?vue&type=script&lang=js"
import style0 from "./stationInfo.vue?vue&type=style&index=0&id=180a46a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.21_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47_l4fxjmgfph2izuapsepws7m6hy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a46a6",
  null
  
)

export default component.exports